import rewards from "../services/rewards";
import broadcasting from "../services/engagement.broadcasting";
import rewardsFormInit from "../services/rewards.form.init";
import _ from "lodash";
import notification from "../services/notification";
import organization from "../services/organization";
import { getField, updateField } from "vuex-map-fields";

export default {
    namespaced: true,
    state: {
        loading: false,
        rewards: [],
        activeRewardUuid: null,
        rewardDetails: null,
        reward: null,
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        perPage: 0,
        errors: null,
        currentPage: 1,
        searching: false,
        editing: false,
        form: rewardsFormInit.formInit(),
        newReward: {},
        currencyOptions: [],
        targetSegmentOptions: [],
        searchCategories: [],
        categories: [],
        branchOptions: [],
        eCodesMaxPage: 1,
        eCodesNextPage: 0,
        eCodesPrevPage: 0,
        eCodesCurrentPage: 1,
        eCodesTotalPerPage: 1,
        eCodesCurrentFirstItem: 1,
        eCodesCurrentLastItem: 1,
        eCodesInitialPageCount: 0,
        eCodes: [],
        eCodesSearchString: "",
        eCodesEmptyText: "No Records Found",
        eCodesIsSearchType: false,
        rewardOptions: null, 
        codes: []
    },
    mutations: {
        updateField,
        loading(state, value = true) {
            state.loading = value;
        },
        reward(state, reward) {
            state.reward = reward;
        },
        rewards(state, rewards) {
            state.rewards = rewards;
            state.loading = false;
        },
        pagination(state, pagination) {
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;

            if (pagination.prev_page === 0) state.perPage = pagination.list.length;
        },
        updateRewards(state, reward) {
            state.rewards.unshift(reward);
        },
        searching(state, searching) {
            state.searching = searching;
            state.loading = false;
        },
        editing(state, editing) {
            state.editing = editing;
        },
        errors(state, errors) {
            state.errors = errors;
        },
        formInit(state, param) {
            state.form = param;
        },
        activeRewardUuid(state, param) {
            state.activeRewardUuid = param;
        },
        currencyOptions(state, options) {
            state.currencyOptions = options;
        },
        searchCategories(state, categories) {
            state.searchCategories = categories;
        },
        categories(state, categories) {
            state.categories = categories;
        },
        targetSegmentOptions(state, options) {
            state.targetSegmentOptions = options;
        },
        branchOptions(state, branchOptions) {
            state.branchOptions = branchOptions;
            state.loading = false;
        },
        eCodesPagination(state, eCodesPagination) {
            state.eCodesTotalPerPage = eCodesPagination.list.length;
            state.eCodesMaxPage = eCodesPagination.max_page;
            state.eCodesPrevPage = eCodesPagination.prev_page;
            state.eCodesNextPage = eCodesPagination.next_page;
            state.eCodesCurrentPage = state.eCodesPrevPage + 1;
            state.eCodesCurrentFirstItem =
                state.eCodesInitialPageCount * state.eCodesPrevPage + 1;
            state.eCodesCurrentLastItem =
                state.eCodesCurrentFirstItem > 0
                    ? state.eCodesCurrentFirstItem +
                    state.eCodesTotalPerPage -
                    1
                    : 0;
        },
        resetECodesPagination(state) {
            state.eCodesMaxPage = 1;
            state.eCodesNextPage = 0;
            state.eCodesPrevPage = 0;
            state.eCodesCurrentPage = 1;
            state.eCodesTotalPerPage = 1;
            state.eCodesCurrentFirstItem = 1;
            state.eCodesCurrentLastItem = 1;
            state.eCodesInitialPageCount = 0;
        },
        eCodes(state, eCodes) {
            state.eCodes = eCodes;
            state.loading = false;
            state.searching = false;
        },
        setECodesInitialPageCount(state, list) {
            state.eCodesInitialPageCount = list.length;
        },
        setRewardDetails(state, details) {
            state.rewardDetails = details;
        },
        setRewardOptions(state, value) {
            state.rewardOptions = value;
        },
        setCodes(state, value) {
            state.codes = value;
        },
        resetForm(state) {
            state.form = rewardsFormInit.formInit();
        }
    },
    getters: {
        getField,
        mobileOutlineRewards: state => {
            let firstFour = _.filter(state.rewards, o => {
                return o.is_enabled === true;
            });
            return _.chunk(firstFour.slice(0, 4), 2);
        },
        firstItemPage: state => {
            return state.perPage * state.prevPage + 1;
        },
        lastItemPage: (state, getters) => (property) => {
            return getters.firstItemPage > 0
                ? getters.firstItemPage + state[property].length - 1
                : 0;
        },
        rewardDetails: state => state.rewardDetails,
        form: state => state.form
    },
    actions: {
        // TODO: Remove after deploying new my rewards tab
        async getRewardsOld({ commit, state }, page) {
            commit("loading");
            try {
                let response = await rewards.getRewardsOld(page);
                commit("rewards", response.list);
                commit("pagination", response);
                commit("searching", false);
            } catch (errors) {
                commit("rewards", null);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getRewards({ commit }, page) {
            commit("loading", true);

            try {
                const response = await rewards.getRewards(page);
                commit("rewards", response.list);
                commit("pagination", response);
                commit("searching", false);
            } catch (errors) {
                commit("rewards", []);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getRewardOptions({ commit }) {
            commit("loading", true);

            try {
                const response = await rewards.getRewardOptions();
                commit("setRewardOptions", response);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getTargetSegmentOptions({ commit }) {
            commit("errors", null);
            try {
                let response = await broadcasting.getTargetSegmentOptions();
                let audienceOptions = [
                    {
                        text: "All Customers",
                        value: "default"
                    }
                ];
                _.forEach(response.options, function (value) {
                    audienceOptions.push({
                        text: value.name,
                        value: value.target_segment_uuid
                    });
                });
                commit("targetSegmentOptions", audienceOptions);
                return response;
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async create({ commit, dispatch }, payload) {
            commit("loading", true);
            commit("errors", null);
            try {
                const { message } = await rewards.createReward(payload);
                notification.success(message);
                dispatch("getRewards");
            } catch (errors) {
                notification.warning("Oops, Cannot create new reward.");
                commit("errors", errors.errors);
            } finally {
                commit("loading", false);
            }
        },
        // TODO: Remove after deploying new my rewards tab
        async createOld({ commit, state }, param) {
            commit("loading");
            try {
                let response = await rewards.createRewardOld(param);
                commit("updateRewards", response.reward_merchant);
                notification.success("“Reward successfully saved.");
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, Cannot create new reward.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async update({ commit, state }, param) {
            commit("loading");

            try {
                let response = await rewards.updateReward(
                    state.activeRewardUuid,
                    param
                );
                let index = _.findIndex(state.rewards, function (row) {
                    return row.uuid === state.activeRewardUuid;
                });

                _.forEach(response.reward_merchant, function (value, key) {
                    state.rewards[index][key] = value;
                });

                state.loading = false;
                notification.success(response.message);
            } catch (errors) {
                notification.warning("Oops, Cannot update reward.");
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async updateOld({ commit, state }, param) {
            commit("loading");

            try {
                let response = await rewards.updateRewardOld(
                    state.activeRewardUuid,
                    param
                );
                let index = _.findIndex(state.rewards, function (row) {
                    return row.uuid === state.activeRewardUuid;
                });

                _.forEach(response.reward_merchant, function (value, key) {
                    state.rewards[index][key] = value;
                });

                state.loading = false;
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, Cannot update reward.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async search({ commit }, param) {
            commit("loading", true);

            try {
                let response = await rewards.search(
                    param.apiFields,
                    param.page
                );
                commit("pagination", response);
                commit("rewards", response.list);
                commit("searching", true);
            } catch (errors) {
                commit("rewards", null);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async searchOld({ commit }, param) {
            commit("loading");
            try {
                let response = await rewards.searchOld(
                    param.apiFields,
                    param.page
                );
                commit("pagination", response);
                commit("rewards", response.list);
                commit("searching", true);
            } catch (errors) {
                commit("rewards", null);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async visibility({ commit, state }, param) {
            commit("loading");
            try {
                let response = await rewards.visibility(
                    param.apiFields,
                    param.uuid
                );
                state.rewards[param.index].is_enabled =
                    param.apiFields.is_enabled;
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async delete({ commit, state }, param) {
            commit("loading");
            try {
                let response = await rewards.delete(param);
                let index = await _.findIndex(state.rewards, function (row) {
                    return row.uuid === param;
                });
                state.rewards.splice(index, 1);
                notification.success("Reward successfully deleted.");
                commit("loading", false);
            } catch (errors) {
                if (errors.errors.message) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot delete reward.");
                }
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async multipleDelete({ commit, state }, param) {
            commit("loading");
            try {
                let response = await rewards.multipleDelete(param);
                if (response.data.not_deleted == 0) {
                    notification.success("Rewards successfully deleted.");
                } else {
                    notification.warning(
                        response.data.not_deleted +
                        " reward(s) cannot be deleted."
                    );
                }
                let rewardsResponse = await rewards.getRewards(
                    state.currentPage
                );
                commit("rewards", rewardsResponse.list);
                commit("pagination", rewardsResponse);
                commit("searching", false);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCurrencies({ commit }) {
            try {
                let response = await rewards.getCurrencies();
                let currencyOptions = _.map(response.currencies, function (
                    value,
                    key
                ) {
                    return { value: key, text: value };
                });
                commit("currencyOptions", currencyOptions);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getSearchCategories({ commit }) {
            try {
                let response = await rewards.getSearchCategories();
                let searchCategories = _.map(response.categories, function (
                    value,
                    key
                ) {
                    return { value: key, text: value };
                });
                commit("searchCategories", searchCategories);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async getCategories({ commit }) {
            try {
                let response = await rewards.getCategories();
                commit("categories", response.categories);
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        async resetForm({ commit, dispatch, state }, form) {
            try {
                if (state.currencyOptions.length < 1) {
                    await dispatch("getCurrencies");
                }
                form.currencyOptions = state.currencyOptions;
                form.selectedCurrency = form.currencyOptions[0].value;
                commit("formInit", form);
                commit("reward", null);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        resetMessageBag({ commit }) {
            commit("errors", null);
            commit("reward", null);
        },
        editing({ commit }, value) {
            commit("editing", value);
        },
        async getBranches({ commit }) {
            commit("loading");
            try {
                let response = await organization.getBranches();
                commit(
                    "branchOptions",
                    response.map(obj => {
                        var rObj = {};
                        rObj["value"] = obj.uuid;
                        rObj["text"] = obj.name;
                        return rObj;
                    })
                );
            } catch (errors) {
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
        resetECodesPagination({ commit }) {
            commit("resetECodesPagination");
        },
        async getECodes({ commit }, param) {
            commit("loading");
            try {
                let response = await rewards.getECodes(param);
                if (param.page == 1) {
                    await commit("setECodesInitialPageCount", response.list);
                }

                await commit("eCodes", response.list);
                await commit("eCodesPagination", response);
            } catch (errors) {
                commit("loading", errors);
            } finally {
                commit("loading", false);
            }
        },
        async viewReward({ commit }, uuid) {
            commit("loading");
            commit("activeRewardUuid", uuid);
            try {
                let { data } = await rewards.viewReward(uuid);
                commit("setRewardDetails", {
                    ...data,
                    categories: data.categories ? data.categories.join(" ") : data.categories,
                    show_display_instruction: data.show_display_instruction ? true : false,
                    voucher_discount_value: data.voucher_type === "Item-Based" ? 0 : data.voucher_discount_value,
                    voucher_discount_parameter: !data.voucher_discount_parameter ? "Php" : data.voucher_discount_parameter,
                    duration_validity: data.duration_validity ? JSON.parse(data.duration_validity) : []
                });
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                commit("loading", false);
            }
        },
        resetRewardDetails({ commit }) {
            commit("setRewardDetails", null);
        },
        initializeForm({ commit, state }) {
            if (!state.editing)
                commit("formInit", rewardsFormInit.initializeForm());
            else
                commit("formInit", { ...rewardsFormInit.initializeForm(), ...state.rewardDetails });
            commit("errors", null);
        },
        async getCodes({ commit }, parameters) {
            commit("loading");
            commit("setCodes", []);

            try {
                const response = await rewards.getCodes(parameters);
                commit("setCodes", response.list ? response.list : []);
                commit("pagination", response);
            } catch (errors) {
                commit("setCodes", []);
                commit("errors", errors);
            } finally {
                commit("loading", false);
            }
        },
    }
};
